<template>
  <v-expansion-panel @click.native.stop>
    <v-expansion-panel-header>Admin</v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-form ref="swayAdminForm">
        <v-row class="mb-n8">
          <v-col cols="12">
            <v-textarea v-model="fine_print" outlined label="Fine Print" rows="2" @blur="handleSave()" @keydown.enter.prevent="$event.target.blur()" />
          </v-col>
        </v-row>

        <v-row class="mb-n4">
          <v-col cols="12">
            <v-text-field
              v-model="fine_print_url"
              :rules="optionalUrlRule"
              outlined
              label="Fine Print URL"
              @blur="handleSave()"
              @keydown.enter="$event.target.blur()"
            />
          </v-col>
        </v-row>

        <template v-if="offerType === 'WEB'">
          <v-row class="mt-n4">
            <v-col cols="12">
              <v-text-field
                v-model="approve_proof_email_template_id"
                outlined
                label="Approve Proof Email Template ID"
                :rules="[emailTemplateIdRule]"
                @blur="handleSave()"
                @keydown.enter="$event.target.blur()"
              />
            </v-col>
          </v-row>

          <v-row class="mt-n4">
            <v-col cols="12">
              <v-text-field
                v-model="deny_proof_email_template_id"
                outlined
                label="Deny Proof Email Template ID"
                :rules="[emailTemplateIdRule]"
                @blur="handleSave()"
                @keydown.enter="$event.target.blur()"
              />
            </v-col>
          </v-row>
        </template>

        <template v-if="isGiveAwayOffer">
          <v-row class="mt-n4">
            <v-col cols="12">
              <v-text-field
                v-model="expiration_description"
                outlined
                label="Expiration text to display"
                @blur="handleSave()"
                @keydown.enter="$event.target.blur()"
              />
            </v-col>
          </v-row>
        </template>
      </v-form>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Vue from 'vue'

import validationRules from '@/utils/validation'

import { isGiveAwayOffer } from '@/models/SwayOffer'

export default Vue.extend({
  name: 'SwayOfferAdminPanel',

  props: {
    offerType: {
      type: String,
      required: true,
    },
    finePrint: {
      type: String,
      default: null,
    },
    finePrintUrl: {
      type: String,
      default: null,
    },
    expirationDescription: {
      type: String,
      default: null,
    },
    approveProofEmailTemplateId: {
      type: String,
      default: null,
    },
    denyProofEmailTemplateId: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    fine_print: null,
    fine_print_url: null,
    expiration_description: null,
    approve_proof_email_template_id: null,
    deny_proof_email_template_id: null,
    optionalUrlRule: validationRules.optionalUrlRules,
  }),

  computed: {
    isGiveAwayOffer() {
      return isGiveAwayOffer(this.offerType)
    },
  },

  mounted: function () {
    this.fine_print = this.finePrint
    this.fine_print_url = this.finePrintUrl
    this.expiration_description = this.expirationDescription
    this.approve_proof_email_template_id = this.approveProofEmailTemplateId
    this.deny_proof_email_template_id = this.denyProofEmailTemplateId
  },

  methods: {
    emailTemplateIdRule(value) {
      return value.length === 0 ? 'Required' : true
    },
    handleSave() {
      if (!this.$refs.swayAdminForm.validate()) return

      this.$emit('save', {
        fine_print: this.fine_print,
        fine_print_url: this.fine_print_url,
        approve_proof_email_template_id: this.approve_proof_email_template_id,
        deny_proof_email_template_id: this.deny_proof_email_template_id,
        expiration_description: this.expiration_description,
      })
    },
  },
})
</script>
